import _ from 'lodash'
import { ATTRIBUTE_DISPLAY_MODE_TYPES } from '../../../../constants/proposalTypes'
import { FormRow, RadioGroupInputField } from '../../../Common/Form'
import { Field } from '../../../Common/forms'
import { IconPopoverLabel } from '../../Common/ProposalForm/FormLabelTooltip/FormLabelTooltip'
import { PopoverImg, ProposalBlock } from '@vzmi/shp_shared_compo'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'
import CurrentPath from '../../../BatchProposal/UpdateAttribute/AttributeRows/CurrentPath'
import NewPathSelect from '../../../BatchProposal/UpdateAttribute/AttributeRows/NewPathSelect'
import ProductModels from '../../../BatchProposal/UpdateAttribute/AttributeRows/ProductModels'
import SpecList from '../../../BatchProposal/UpdateAttribute/AttributeRows/SpecList'
import {
  getIsClusterDependOnCatItem,
  getSelectedOptions
} from '../../../BatchProposal/UpdateAttribute/AttributeRows'
import styles from './index.css'

const UpdateAttribute = props => {
  const {
    initialize,
    listing = {},
    readOnly,
    menuData,
    // need fix
    selectedOptionMap,
    optionsMap,
    updateMenuData,
    updateCategoryOptions,
    updateFormListingWithAttributes,
    triggerOptionLoadingState
  } = props
  const {
    id,
    subStationId,
    isNewPathSelectable,
    isInConsistentProduct: isInConsistentProductFromListing
  } = listing
  const currentPaths = [
    'zoneName',
    'subStationName'
  ]
  // 只有修改頁賣場的商品才會有不一致的情況
  // 進入確認、檢視頁的時候已經重新選擇規格表，所以一率把商品的規格表當作一致
  // 額外這樣判斷是因為在檢視頁只能取得賣場資料從 productStructuredDataList 驗證起來規格表還是不一致的
  // 因為這項功能沒有要修改"賣場的規格表"，所以他如果一開始不一致到檢視頁仍然會不一致
  const isInConsistentProduct = readOnly
    // 確認、檢視頁一率當作商品的規格表一致
    ? false
    : isInConsistentProductFromListing
  // 已選擇的父類、子類及規格選項
  const selectedOptions = isInConsistentProduct
    // 賣場的商品規格表不一致時直接要求重選
    ? []
    : getSelectedOptions(selectedOptionMap, id)
  const selectedOptionValues = _.map(selectedOptions, 'value')
  const categoryPathOptions = _.get(optionsMap, subStationId, [])
  // 需要重選規格表的條件
  const isNeedSelectNewPath = (
    // 未選完整規格表(父類、子類、規格)
    (_.size(selectedOptionValues) !== 3) ||
    // 賣場裡所有商品的規格表編號如果有不一致會要求重選規格表
    // 選擇後 isInConsistentProduct 會變成 false
    isInConsistentProduct
  )
  const isNewPathSelectDisabled = (
    readOnly ||
    // 父類、子類、規格有查不到的情況需要重選，查不到時已選擇的項目會湊不齊
    (
      !isNeedSelectNewPath &&
      // 重選過規格表後賣場會標記成 isNewPathSelectable=true
      // 讓使用者可以再次重新選取
      // (重選後選錯當下 selectedOptionValues 變成已選取 3 項，另外用一個 flag 紀錄是否可以重選)
      !isNewPathSelectable
    )
  )
  // 判斷規格表是不是從目前賣場的子類底下找到的
  const isClusterDependOnCatItem = getIsClusterDependOnCatItem(listing, menuData)
  return (
    <>
      <ProposalBlock>
        <FormRow
          label='選擇規格表'
          labelAlign='top'
        >
          <div
            data-role='full-category-path'
            className={styles.fullCategoryPath}
          >
            <CurrentPath paths={currentPaths} />
            <NewPathSelect
              listing={listing}
              value={selectedOptionValues}
              options={categoryPathOptions}
              currentPathOptions={selectedOptions}
              change={initialize}
              updateMenuData={updateMenuData}
              updateCategoryOptions={updateCategoryOptions}
              updateFormListingWithAttributes={updateFormListingWithAttributes}
              triggerOptionLoadingState={triggerOptionLoadingState}
              isNeedSelectNewPath={isNeedSelectNewPath}
              isClusterDependOnCatItem={isClusterDependOnCatItem}
              disabled={isNewPathSelectDisabled}
            />
          </div>
        </FormRow>
        <FormRow
          labelAlign='top'
          label={(
            <IconPopoverLabel
              popoverContent={(
                <PopoverImg
                  url={`${CDN}/img/tooltip_value.png`}
                  width={500}
                  height={400}
                />
              )}
            >
              商品屬性
            </IconPopoverLabel>
          )}
        >
          <ProductModels
            listing={listing}
          />
        </FormRow>
        <FormRow
          labelAlign='top'
          label={(
            <IconPopoverLabel
              popoverContent={(
                <PopoverImg
                  url={`${CDN}/img/tooltip_attributes.png`}
                  width={500}
                  height={610}
                />
              )}
            >
              商品規格
            </IconPopoverLabel>
          )}
        >
          <Field
            name='attributeDisplayMode'
            component={RadioGroupInputField}
            options={ATTRIBUTE_DISPLAY_MODE_TYPES}
            disabled={readOnly}
          />
        </FormRow>
      </ProposalBlock>
      {/* 需要重選規格表或賣場的商品規格表不一致時隱藏規格項目，待重選後顯示規格項目 */}
      {!isNeedSelectNewPath && (
        <ProposalBlock
          data-role='sub-section'
        >
          <SpecList
            disabled={readOnly}
            visible
          />
        </ProposalBlock>
      )}
    </>
  )
}

export default UpdateAttribute
